/**
 * Unilar Newsletter
 * Form validation for newsletter signup.
 */

class UnilarNewsletter {
  constructor(section) {
    this.section = section;
    this.form = section.querySelector('.unilar-newsletter__form');
    this.nameInput = section.querySelector('[data-newsletter-name]');
    this.emailInput = section.querySelector('[data-newsletter-email]');
    this.init();
  }

  init() {
    this.initValidation();
  }

  initValidation() {
    if (!this.form) return;

    if (this.nameInput) {
      this.nameInput.addEventListener('input', () => this.validateName());
      this.nameInput.addEventListener('invalid', () => this.validateName());
    }

    if (this.emailInput) {
      this.emailInput.addEventListener('input', () => this.validateEmail());
      this.emailInput.addEventListener('invalid', () => this.validateEmail());
    }

    this.form.addEventListener('submit', (event) => {
      const nameValid = this.validateName();
      const emailValid = this.validateEmail();

      if (!nameValid || !emailValid) {
        event.preventDefault();
        const firstInvalid = !nameValid ? this.nameInput : this.emailInput;
        firstInvalid?.focus();
      }
    });
  }

  validateName() {
    if (!this.nameInput) return true;

    const value = this.nameInput.value.trim();
    const hasFullName = /^\S+\s+\S+/.test(value);

    if (!value) {
      this.nameInput.setCustomValidity('Informe o nome completo.');
      return false;
    }

    if (!hasFullName) {
      this.nameInput.setCustomValidity('Informe o nome completo (nome e sobrenome).');
      return false;
    }

    this.nameInput.setCustomValidity('');
    return true;
  }

  validateEmail() {
    if (!this.emailInput) return true;

    const value = this.emailInput.value.trim();
    const hasValidDomain = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(value);

    if (!value) {
      this.emailInput.setCustomValidity('Informe o e-mail.');
      return false;
    }

    if (!hasValidDomain) {
      this.emailInput.setCustomValidity('Informe um e-mail válido com domínio (ex: nome@email.com).');
      return false;
    }

    this.emailInput.setCustomValidity('');
    return true;
  }
}

function initUnilarNewsletter() {
  document.querySelectorAll('[data-unilar-newsletter]').forEach((section) => {
    if (section.dataset.unilarNewsletterInit === 'true') return;
    section.dataset.unilarNewsletterInit = 'true';
    new UnilarNewsletter(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUnilarNewsletter);
} else {
  initUnilarNewsletter();
}

document.addEventListener('shopify:section:load', initUnilarNewsletter);
